import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import { Typography } from '../Typography';
import type { HasRightPadding, TableCellAlign } from './TableBodyCell';

type TableHeaderCellProps = TableCellAlign & HasRightPadding;

export const TableHeaderCell = ({
  children,
  align = 'left',
  noRightPadding = false,
}: PropsWithChildren<TableHeaderCellProps>) => (
  <div
    className={classNames('p-0 pb-[7px] align-top leading-none text-[13px]', {
      'text-start': align === 'left',
      'text-end': align === 'right',
      'text-center': align === 'center',
      'pr-0': noRightPadding,
      'pr-4': !noRightPadding,
    })}
  >
    <Typography variant="caption-xs" color="tertiary">
      {children}
    </Typography>
  </div>
);
